export default `
<div id="skiptocontent" ng-class="{'skip--2026': designRefresh}"><a href="#main-content-container" class="skip" ng-keydown="handleSkipKeydown($event)" ng-click="skipToMainContent()">skip to main content</a></div>
<!-- this should be visible all the time with the flag off, but only visible to signed in users with the flag on  -->
<ngf-tester-navigation-sidebar ng-if="showAuthenticatedUtest" logo-src="/utest-static/assets/images/uTestLogoNav.svg" compact-logo-src="/utest-static/assets/images/uTestLogoU.svg"></ngf-tester-navigation-sidebar>
<alert-service ng-if="showAuthenticatedUtest"></alert-service>
<ut-impersonation-overlay></ut-impersonation-overlay>
<div ng-if="showAuthenticatedUtest" loading-indicator class="ntux-wrapper-all" id="wrapperAll">
  <ngf-tester-navigation-header logo-src="/utest-static/assets/images/uTestLogoNav.svg" search-query="{{$state.params.query}}" (search-submit)="$state.go('searchresult', {contentType: 'all', query: $event})"></ngf-tester-navigation-header>

  <div auto-padding="nav-bar-container" auto-padding-event="adjust-nav-padding" id="mainUiView" class='main-ui-view' scrolly scroll-target='#navBar' autoscroll="true">
    <alert-message current-user="currentUser"></alert-message>
    <ut-persona-verification-banner
      ng-if="userIdentityVerification && personaVerificationUrl"
      [link]="personaVerificationUrl"
    ></ut-persona-verification-banner>
    <main ui-view id="main-content-container" ng-class="{'ntux-background-color' : ($state.includes('home') || $state.includes('homeApp')
    || $state.includes('activity')
    || $state.includes('community')
    || $state.includes('courses')
    || $state.includes('academy')
    || $state.includes('tracks')
    || $state.includes('singlecourse')
    || $state.includes('referralCampaignsIndex'))}"></main>
  </div>
</div>
<landing-messages></landing-messages>

<unauthenticated-container ng-if="!showAuthenticatedUtest"></unauthenticated-container>
</div>


  <!-- unauthenticated-footer -->
`;
